import * as React from 'react';

export const AverageEngagementScore = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="fire">
      <path
        id="Vector"
        opacity="0.4"
        d="M17.356 8.65223C17.213 8.50723 16.996 8.46323 16.81 8.54023C16.622 8.61723 16.499 8.80024 16.499 9.00324C16.499 9.76524 16.338 10.4613 16.022 11.0733C15.529 12.0283 14.726 12.6433 14.055 13.0183C16.915 6.45026 11.337 2.62723 11.277 2.58723C11.123 2.48423 10.925 2.47527 10.764 2.56227C10.601 2.64927 10.5 2.81924 10.5 3.00324C10.5 5.20024 9.037 6.49727 7.621 7.75227C7.275 8.05827 6.942 8.35422 6.646 8.65022C5.142 10.1542 4.5 11.7552 4.5 14.0042C4.5 18.1392 7.864 21.5042 12 21.5042C16.136 21.5042 19.5 18.1392 19.5 14.0042C19.5 11.9872 18.719 10.0362 17.356 8.65223Z"
        fill="black"
      />
    </g>
  </svg>
);
